import { useState } from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { TarifsHero } from '../components/sections/tarifs/TarifsHero';
import { TextAgentPricing } from '../components/sections/tarifs/TextAgentPricing';
import { VoiceAgentPricing } from '../components/sections/tarifs/VoiceAgentPricing';
import { ClarteAbsolue } from '../components/sections/tarifs/ClarteAbsolue';
import { TarifsCTA } from '../components/sections/tarifs/TarifsCTA';

export default function TarifsPage() {
  const [isAnnual, setIsAnnual] = useState(false);

  return (
    <div data-testid="tarifs-page" className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      <main>
        <TarifsHero isAnnual={isAnnual} setIsAnnual={setIsAnnual} />
        <TextAgentPricing isAnnual={isAnnual} />
        <VoiceAgentPricing />
        <ClarteAbsolue />
        <TarifsCTA />
      </main>
      <Footer />
    </div>
  );
}
